<template>
  <div class="rep__group" v-if="repgroup">
    <div class="wrapper main">
      <div class="rep__pre">is represented in {{region.toUpperCase()}} by:</div>
      <div class="inner--block">
        <div class="bold rep__name">{{repgroup.business_name}}</div>
        <a :href="repgroup.website" target="_blank">{{repgroup.website}}</a>
        <a :href="'tel:'+repgroup.phone">{{repgroup.phone}}</a>
      </div>
    </div>
    <div class="wrapper">
      <h2>Rep Contacts</h2>
      <div class="inner">
        <rep-card
          v-for="rep in currentreps"
          v-bind:key="rep.id"
          v-bind:rep="rep">
        </rep-card>
      </div>
    </div>
    <div class="wrapper">
      <h2>Represented Lines</h2>
      <div class="inner">
        <factory-card
          v-for="factory in repgroup.factories"
          v-bind:key="factory"
          v-bind:factoryid="factory">
        </factory-card>
      </div>
    </div>
  </div>
  <div class="error__message" v-else>
    No Rep Group has been set for this region
  </div>
</template>

<script>
import {store} from '@/store'
import RepCard from '@/components/mainpage/RepCard'
import FactoryCard from '@/components/mainpage/FactoryCard' 
export default {
  name: 'RepGroup',
  computed: {
    repgroup: function(){
      return store.state.repgroup
    },
    region: function(){
      return store.state.region
    },
    currentreps: function(){
      return store.state.currentreps
    }
  },
  components: {
    RepCard,
    FactoryCard
  },
  watch: {
    repgroup: function(val) {
      if(val){
        store.dispatch('getReps', val.id)
      }
    }
  }
}
</script>

<style scoped lang="less">
.shadow {
  box-shadow: 0px 2px 12px 0px rgba(0,0,0,0.25);
}
.bold {
  font-weight: bold;
  font-size: 1.25em;
}
.wrapper {
  display: block;
  box-sizing: border-box;
  padding: 12px 0px;
  border-bottom: dashed 1px lightgray;
  .rep__pre {
    font-style: italic;
    font-size: 0.8em;
    padding: 0px 24px 12px 24px;
    box-sizing: border-box;
  }
  .inner {
    display: flex;
    padding: 0px 24px;
    flex-direction: row;
    flex-wrap: wrap;
    align-items: stretch;
    justify-content: flex-start;
    box-sizing: border-box;
    @media screen and (max-width: 468px){
      padding: 0px 12px;
    }
  }
  .inner--block {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    padding: 6px 24px;
    a {
      display: inline-block;
      margin-top: 3px;
      font-size: 0.8em;
    }
    .rep__name {
      padding-bottom: 6px;
    }
  }
  &.main {
    background-color: white;
    padding-top: 0px;
    
  }
}

h2 {
  display: block;
  margin: 0px;
  width: 100%;
  padding: 6px 24px;
  box-sizing: border-box;
  font-size: 1em;
  text-transform: uppercase;
  font-weight: bold;
  font-style: italic;
}
.error__message {
  padding: 24px;
  box-sizing: border-box;
}
</style>



// WEBPACK FOOTER //
// src/components/mainpage/RepGroup.vue